import React, { useContext } from "react";
import { useSelector } from "react-redux";
import { ProfileSection } from "../context/ProfileContext";
import { useTranslation } from "react-i18next";
const HowToUse = () => {
  const { t } = useTranslation();
  const { ProfileShowHideFunc } = useContext(ProfileSection);
  const folio = useSelector((state) => state.folio);

  return (
    <div>
      <p className="text-right mb-4">{folio.title}</p>
      <div
        className="textCard text-justify p-3 m-3"
        dangerouslySetInnerHTML={{ __html: folio.body }}
      ></div>
      <div className="d-flex flex-wrap justify-content-end mt-5 mb-2">
        <div
          onClick={() => ProfileShowHideFunc("setting")}
          className="mx-3 d-flex justify-content-center align-items-center flex-column text-center"
        >
          <span className="profileAddUser bg-white d-block icon-left-1 cursor"></span>
          <small className="fn10 mt-1">{t("بازگشت")}</small>
        </div>
      </div>
    </div>
  );
};

export { HowToUse };
